<!--87 markAsChanged-->
<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Produkte als geändert markieren' | translate }}</div>
  <dx-switch [(value)]="markProductsAsChanged"></dx-switch>
</div>
<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Kategorien als geändert markieren' | translate }}</div>
  <dx-switch [(value)]="markCategoriesAsChanged"></dx-switch>
</div>
